
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Button } from "../ui/button";
import { Trash2, CreditCard, Plus, Minus, ChevronDown } from "lucide-react";
import { useState, useEffect } from "react";
import { postRequest } from "../../services/mainApp.service";
import { useSelector } from "react-redux";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import "../../../src/App.css";
import { Input } from "../ui/input";
import { Table, TableHeader } from "../ui/table";
import { message } from "antd";
import { RestrictCardDetail } from "../../utils/PosSettingConstants";
import { useCheckPosSetting } from "../../customHooks/PosCustomHooks";
import { Label } from "../ui/label";
import { CustomerCombobox } from "./CustomerCombobox ";
import { Loader2, Check } from "lucide-react";

export function OrderPayment({
    open,
    onOpenChange,
    paymentDetail,
    setSelectedTax,
    paymentMode,
    handleCheckout,
    phone_Number,
    customer_Name,
    phoneId,
    customerId,
    onBillDiscount,
    billDiscountDisabled = false,
}) {
    const { subtotal, totalDiscount, selectedTax, taxOptions, taxAmount, total, subtotalBeforeDiscount, deliveryCharges } = paymentDetail;
    const [receiveAmount, setReceiveAmount] = useState(0);
    const [orderPaymentList, setOrderPaymentList] = useState([]);
    const [remainingBillAmount, setRemainingBillAmount] = useState(total.toFixed(2));
    const [IsFoc, setIsFoc] = useState(false);
    let paymentInfoObj_Initial = {
        CareOff: null,
        Tip: null,
        BankName: null,
        CardNumber: null,
    };
    const [paymentInfoObj, setPaymentInfoObj] = useState(paymentInfoObj_Initial);
    const [IsCard, setIsCard] = useState(false);
    const restrictCardDetailSetting = useCheckPosSetting(RestrictCardDetail);
    const [IsParty, setIsParty] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(phone_Number || "");
    const [searchingCustomer, setSearchingCustomer] = useState(false);
    const userData = useSelector((state) => state.authReducer);
    const [customerNameList, setCustomerNameList] = useState([]);
    const [customerName, setCustomerName] = useState("");
    const [selectedCustomerId, setSelectedCustomerId] = useState(customerId || null);
    const [customerData, setCustomerData] = useState([]);
    const [selectedPhoneId, setSelectedPhoneId] = useState(phoneId || null);
    const [returnAmount, setReturnAmount] = useState(0);

    useEffect(() => {

        SetReceiveAmountFunc();

    }, [orderPaymentList, total]);

    useEffect(() => {

        ClearAllFields();

    }, [open]);



    const ClearAllFields = () => {
        setReceiveAmount(0);
        setOrderPaymentList([]);
        setRemainingBillAmount(total.toFixed(2));
        setIsFoc(false);
        setIsCard(false);
        setPaymentInfoObj(paymentInfoObj_Initial);
        setIsParty(false);
        setPhoneNumber(phone_Number || "");
        setCustomerName(customer_Name || "");
    };

    const onClickPaymentMode = (objPaymentMode) => {
        let isFlag = false;
        let Msg = '';
        setIsCard(false);
        setIsFoc(false);

        // Find the matching tax for the payment mode
        let matchingTax = taxOptions.find(t =>
            t.IsCashType == objPaymentMode.IsCashType &&
            t.IsCreditType == objPaymentMode.IsCreditType &&
            t.IsFoc == objPaymentMode.IsFoc &&
            t.IsPartyAccount == objPaymentMode.IsPartyAccount &&
            t.IsPosType == true
        );

        const CashPaymentExists = orderPaymentList.filter(a => a.CashPaymentExists === true);

        if (CashPaymentExists.length > 0) {

            matchingTax = taxOptions.find(t =>
                t.IsCashType == true &&
                t.IsPosType == true
            );
        }

        if (objPaymentMode.IsFoc) {
            matchingTax = taxOptions.find(t =>
                t.IsCashType == true &&
                t.IsPosType == true
            );
        }

        // Validate payment mode conditions
        if (objPaymentMode?.IsCashType && !objPaymentMode?.IsPartyAccount) {
            if (selectedTax?.IsCashType || matchingTax?.IsCashType) {
                isFlag = true;
            }
            else {
                Msg = 'Please Select Tax Type - Cash';
            }
        }
        else if (objPaymentMode?.IsCreditType && !objPaymentMode?.IsPartyAccount) {
            if (selectedTax?.IsCreditType || matchingTax?.IsCreditType || orderPaymentList?.length > 0) {
                isFlag = true;
                setIsCard(true);
            }
            else {
                Msg = 'Please Select Tax Type - Card';
            }
        }
        else if (objPaymentMode?.IsFoc) {
            if (selectedTax?.IsCashType || matchingTax?.IsCashType) {
                if (orderPaymentList?.length > 0) {
                    Msg = 'Order cannot partially FOC';
                }
                else {
                    isFlag = true;
                    setIsFoc(true);
                }
            }
            else {
                Msg = 'Please Select Tax Type - Cash';
            }
        }
        else if (objPaymentMode?.IsPartyAccount && objPaymentMode?.IsCashType) {
            if (selectedTax?.IsCashType || matchingTax?.IsCashType) {
                isFlag = true;
                setIsParty(true);
                handleCustomerSearch();
            }
            else {
                Msg = 'Please Select Tax Type - Cash';
            }
        }
        else if (objPaymentMode?.IsPartyAccount && objPaymentMode?.IsCreditType) {
            if (selectedTax?.IsCreditType || matchingTax?.IsCreditType) {
                isFlag = true;
                setIsParty(true);
                handleCustomerSearch();
            }
            else {
                Msg = 'Please Select Tax Type - Card';
            }
        }

        // If validation fails, show error and return
        if (!isFlag) {
            if (Msg) {
                message.error(Msg);
            }
            return;
        }

        // Check if payment mode already exists
        const isExist = orderPaymentList?.filter((a) => a.PaymentModeId == objPaymentMode.PaymentModeId);
        if (isExist.length > 0) {
            message.warning('This payment mode is already added');
            return;
        }



        // Calculate the total bill amount with the tax percentage
        const subtotalAfterDiscount = subtotal - totalDiscount;

        // Get tax percentage from matching tax or current selected tax
        const taxToUse = matchingTax || selectedTax;
        const taxPercentage = parseFloat(taxToUse?.GSTPercentage || 0);

        // Calculate tax amount based on subtotalBeforeDiscount
        const calculatedTaxAmount = (subtotalBeforeDiscount * taxPercentage) / 100;

        // Calculate total bill amount (subtotal after discount + tax)
        const calculatedTotal = subtotalAfterDiscount + calculatedTaxAmount + deliveryCharges;

        // Calculate remaining amount after existing payments
        const existingPayments = orderPaymentList || [];
        const existingPaymentTotal = existingPayments.reduce((sum, payment) => {
            return sum + parseFloat(payment.ReceivedAmount || 0);
        }, 0);

        const remainingAmount = calculatedTotal - existingPaymentTotal;

        // Add the payment mode with the remaining amount (or full amount if no existing payments)
        const paymentAmount = remainingAmount > 0 ? remainingAmount : calculatedTotal;
        const receiveAmountValue = parseFloat(receiveAmount) > 0 ? receiveAmount : paymentAmount.toFixed(2);

        const objPayment = {
            PaymentModeId: objPaymentMode.PaymentModeId,
            PaymentMode: objPaymentMode.PaymentMode,
            TotalAmount: paymentAmount.toFixed(2),
            ReceivedAmount: objPaymentMode.IsCashType ? (receiveAmountValue || paymentAmount) : paymentAmount,
            ReturnAmount: objPaymentMode.IsCashType ? (returnAmount || 0) : 0,
            CashPaymentExists: objPaymentMode.IsCashType ? true : false,
            CardPaymentExists: objPaymentMode.IsCreditType ? true : false,
        };

        // Add payment mode to existing payments
        setOrderPaymentList([...existingPayments, objPayment]);

        // Update remaining bill amount
        const newTotalPaymentAmount = existingPaymentTotal + parseFloat(objPayment.ReceivedAmount);
        const newRemainingAmount = calculatedTotal - newTotalPaymentAmount;
        setRemainingBillAmount(newRemainingAmount >= 0 ? newRemainingAmount.toFixed(2) : 0);
        setReceiveAmount(newRemainingAmount >= 0 ? newRemainingAmount.toFixed(2) : 0);

        const CardPaymentExists = orderPaymentList.filter(a => a.CardPaymentExists === true);

        if (CardPaymentExists.length > 0) {
            setIsCard(true);
        }

        setReturnAmount(0);
    };


    const SetReceiveAmountFunc = () => {

        const totalPaymentAmount = orderPaymentList.reduce((accumulator, currentItem) => {
            // return parseFloat(accumulator) + parseFloat(currentItem.TotalAmount);
            return parseFloat(accumulator) + parseFloat(currentItem.ReceivedAmount);
        }, 0);

        if (totalPaymentAmount > 0) {
            if (totalPaymentAmount < total.toFixed(2)) {
                setReceiveAmount((totalPaymentAmount - total.toFixed(2)) * -1);
                setRemainingBillAmount((totalPaymentAmount - total.toFixed(2)) * -1);
            }
            else if (totalPaymentAmount > total.toFixed(2)) {
                setReceiveAmount(0);
                setRemainingBillAmount(0);
            }
            else {
                setReceiveAmount(totalPaymentAmount - total.toFixed(2));
                setRemainingBillAmount(totalPaymentAmount - total.toFixed(2));
            }
        }
        else if (totalPaymentAmount == 0) {
            setReceiveAmount(total.toFixed(2));
            setRemainingBillAmount(total.toFixed(2));
        }
    };


    const onRemovePaymentItem = (PaymentModeId) => {
        const arr = orderPaymentList?.filter((a) => a.PaymentModeId != PaymentModeId);
        setOrderPaymentList(arr);
        SetReceiveAmountFunc();


        let checkPaymentMode = paymentMode?.find(a => a.PaymentModeId == PaymentModeId);

        if (checkPaymentMode.IsFoc) {
            setIsFoc(false);
        }

        if (checkPaymentMode.IsCreditType) {
            setIsCard(false);
        }

        if (checkPaymentMode.IsPartyAccount) {
            setIsParty(false);
        }
    };

    const onSavePay = () => {

        if (orderPaymentList?.length > 0) {

            const totalReceivedAmount = orderPaymentList.reduce((sum, payment) => {
                return sum + parseFloat(payment.ReceivedAmount);
            }, 0);

            const totalBillAmount = total.toFixed(2);

            if (totalReceivedAmount >= totalBillAmount) {
                let isFlag = true;

                const orderPaymentIds = orderPaymentList.map(item => item.PaymentModeId);

                const filteredPaymentMode = paymentMode.filter(pm => orderPaymentIds.includes(pm.PaymentModeId));

                if (filteredPaymentMode?.length > 0) {
                    const hasFoc = filteredPaymentMode.some(payment => payment.IsFoc);
                    const hasCredit = filteredPaymentMode.some(payment => payment.IsCreditType);
                    const hasPartyAccount = filteredPaymentMode.some(payment => payment.IsPartyAccount);

                    if (hasFoc && paymentInfoObj.CareOff == null) {
                        isFlag = false;
                    }

                    if (hasCredit
                        && restrictCardDetailSetting
                        && (paymentInfoObj.BankName == null || paymentInfoObj.CardNumber == null)) {
                        isFlag = false;
                    }

                    if (hasPartyAccount) {

                        if (selectedPhoneId == null && phoneNumber == "") {
                            isFlag = false;
                        }

                        if (selectedCustomerId == null && customerName == "") {
                            isFlag = false;
                        }
                    }
                }

                if (isFlag == true) {

                    const obj = {
                        tblOrderPayment: orderPaymentList,
                        info: paymentInfoObj,
                        partyAccountInfo: {
                            PhoneId: selectedPhoneId,
                            PhoneNumber: phoneNumber,
                            CustomerId: selectedCustomerId,
                            CustomerName: customerName
                        }
                    };

                    handleCheckout(obj, true);
                    onOpenChange(false);
                }
                else {
                    message.error('Please fill all required fields');
                }
            }
            else {
                message.error('Please enter sufficient payment amount');
            }
        }
        else {
            message.error('Please enter payment amount and payment mode');
        }
    };

    const onChangeSelectedTax = (gstId) => {

        const tax = taxOptions.find(t => t.GSTId == gstId);
        if (tax) setSelectedTax(tax);

        setOrderPaymentList([]);

        ClearAllFields();

    };

    const handleCustomerSearch = async () => {
        if (!phoneNumber) return;

        setSearchingCustomer(true);

        try {
            const response = await postRequest("CrudCustomer", {
                OperationId: 1,
                CompanyId: userData.CompanyId,
                PhoneNumber: phoneNumber,
                UserId: userData.UserId,
                UserIP: userData.UserIP || "1.1.1.1"
            });

            if (response.data.Response) {
                const table = response.data.DataSet?.Table || [];
                const table1 = response.data.DataSet?.Table1 || [];

                setCustomerNameList(table1.map(c => c.CustomerName) || []);
                setCustomerData(table1 || []);
                setCustomerName(table1.length === 1 ? table1[0].CustomerName : "");
                setSelectedCustomerId(table1.length === 1 ? table1[0].CustomerId : null);
                setSelectedPhoneId(table.length === 1 ? table[0].PhoneId : null);
            }

        } catch (error) {
            console.error("Error searching customer:", error);
        } finally {
            setSearchingCustomer(false);
        }
    };

    const handleCustomerSelect = (customerName) => {

        setCustomerName(customerName);
        const selectedCustomer = customerData.find(c => c.CustomerName === customerName);
        if (selectedCustomer) {
            setSelectedCustomerId(selectedCustomer.CustomerId);
        } else {
            setSelectedCustomerId(null);
        }
    };

    const handleReceiveAmountChange = (e) => {

        const value = e.target.value;
        setReceiveAmount(value);
        setRemainingBillAmount(value);

        const totalPaymentAmount = orderPaymentList.reduce((accumulator, currentItem) => {
            return parseFloat(accumulator) + parseFloat(currentItem.ReceivedAmount);
        }, 0);

        const diff = parseFloat(value) - (total - totalPaymentAmount);

        setReturnAmount(diff >= 0 ? diff.toFixed(2) : 0);

    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-3xl max-h-[100vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-semibold text-center">
                        Order Payment
                    </DialogTitle>
                </DialogHeader>

                <div className="container_orderpayment">
                    <div className="box_orderpayment p-4 border-t border-border space-y-3">
                        {/* <div className="box_orderpayment"> */}
                        <div className="flex justify-between text-sm">
                            <span>Sub Total : </span>
                            <span> {subtotal.toFixed(2)}</span>
                        </div>

                        {totalDiscount > 0 && (
                            <div className="flex justify-between text-sm text-green-600">
                                <span>Discount : </span>
                                <span> {totalDiscount.toFixed(2)}</span>
                            </div>
                        )}


                        {/* Tax Amount - Only show if GST > 0 */}
                        {selectedTax && parseFloat(selectedTax.GSTPercentage) > 0 && (
                            <div className="flex justify-between items-center text-sm">
                                {/* Container for 'Tax' label and Select dropdown */}
                                <div className="flex items-center space-x-2">
                                    <span className="font-medium">Tax </span>

                                    <Select
                                        value={selectedTax ? selectedTax.GSTId.toString() : ""}
                                        onValueChange={(value) => {

                                            onChangeSelectedTax(value);
                                        }}
                                    >
                                        <SelectTrigger className="w-full">
                                            <SelectValue placeholder="Select tax type" />
                                        </SelectTrigger>
                                        <SelectContent>
                                            {taxOptions
                                                .map((tax) => (
                                                    <SelectItem key={tax.GSTId} value={tax.GSTId.toString()}>
                                                        {tax.PaymentMode} - {tax.GSTPercentage}%
                                                    </SelectItem>
                                                ))}
                                        </SelectContent>
                                    </Select>
                                </div>

                                {/* Display the tax amount */}
                                <span className="font-semibold"> {taxAmount.toFixed(2)}</span>
                            </div>
                        )}

                        <div className="flex justify-between text-sm">
                            <span>Del Charge : </span>
                            <span> {deliveryCharges.toFixed(2)}</span>
                        </div>

                        <div className="flex justify-between font-semibold">
                            <span>Total Bill : </span>
                            <span>{total.toFixed(2)}</span>
                        </div>

                        <div className="flex justify-between text-sm">
                            <span>Receive Amount : </span>
                            <span>
                                <Input
                                    id="receiveAmount"
                                    value={remainingBillAmount}
                                    // onChange={(e) => {
                                    //     setReceiveAmount(e.target.value);
                                    //     setRemainingBillAmount(e.target.value)
                                    // }}
                                    onChange={handleReceiveAmountChange}
                                    placeholder="Enter Receive Amount"
                                    className="mt-1"
                                />
                            </span>
                        </div>

                        <div className="flex justify-between text-sm">
                            <span>Return Amount</span>
                            <span>
                                <Input
                                    id="returnAmount"
                                    value={returnAmount}
                                    // onChange={(e) => setPhoneNumber(e.target.value)}
                                    // onBlur={handleCustomerSearch}
                                    placeholder="Enter Return Amount"
                                    className="mt-1"
                                    readOnly={true}
                                />
                            </span>
                        </div>

                    </div>
                    <div className="box_orderpayment p-4 border-t border-border">
                        <div className="flex flex-wrap gap-3">
                            {paymentMode && paymentMode.map((a) => (
                                <Button
                                    key={a.PaymentModeId}
                                    size="lg"
                                    style={{ width: '100px' }}
                                    onClick={() => onClickPaymentMode(a)}
                                >
                                    {a.PaymentMode}
                                </Button>
                            ))}
                        </div>
                    </div>
                    <div className="box_orderpayment p-4 border-t border-border space-y-3">
                        <Table>
                            <thead>
                                <tr>
                                    <th>Payment Mode</th>
                                    <th>Amount</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>

                                {orderPaymentList && (
                                    orderPaymentList?.map((a) => (
                                        <tr key={a.PaymentModeId}>
                                            <td>
                                                {a.PaymentMode}
                                            </td>
                                            <td>
                                                {/* {a.TotalAmount} */}
                                                {a.ReceivedAmount}
                                            </td>
                                            <td>
                                                <Button
                                                    variant="destructive"
                                                    size="sm"
                                                    className="text-xs"
                                                    onClick={() => onRemovePaymentItem(a.PaymentModeId)}>
                                                    <Trash2 className="h-4 w-4" />
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                )}

                            </tbody>
                        </Table>
                    </div>
                </div>

                <DialogFooter>

                    {onBillDiscount && (
                        <Button
                            size="lg"
                            variant="secondary"
                            style={{ width: '140px' }}
                            disabled={billDiscountDisabled}
                            onClick={() => {
                                onBillDiscount();
                            }}
                        >
                            Bill Discount
                        </Button>
                    )}

                    {IsFoc ?
                        <>
                            <Input
                                id="careOfName"
                                value={paymentInfoObj.CareOff}
                                onChange={(e) => {
                                    setPaymentInfoObj({ ...paymentInfoObj, CareOff: e.target.value });
                                }}
                                placeholder="Enter Care Off"
                                className="mt-1"
                            /></> : <></>}

                    {IsCard ?
                        <>
                            <Input
                                id="tip"
                                value={paymentInfoObj.Tip}
                                onChange={(e) => {
                                    setPaymentInfoObj({ ...paymentInfoObj, Tip: e.target.value });
                                }}
                                placeholder="Enter Tip"
                                className="mt-1"
                            />
                            <Input
                                id="bank"
                                value={paymentInfoObj.BankName}
                                onChange={(e) => {
                                    setPaymentInfoObj({ ...paymentInfoObj, BankName: e.target.value });
                                }}
                                placeholder="Enter Bank Name"
                                className="mt-1"
                            />
                            <Input
                                id="cardnumber"
                                value={paymentInfoObj.CardNumber}
                                onChange={(e) => {
                                    setPaymentInfoObj({ ...paymentInfoObj, CardNumber: e.target.value });
                                }}
                                placeholder="Enter Card Number"
                                className="mt-1"
                            />
                        </>
                        : <></>}

                    {IsParty ?
                        <>
                            <div className="flex items-center content-center w-full gap-3">
                                <div className="relative w-1/2">
                                    <Label htmlFor="phoneNumber" className="text-lg font-medium">
                                        Phone Number
                                    </Label>
                                    <Input
                                        id="phoneNumber"
                                        value={phoneNumber || phone_Number}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        onBlur={handleCustomerSearch}
                                        placeholder="Enter phone number"
                                        className="mt-1"
                                        disabled={searchingCustomer}
                                    />
                                    {searchingCustomer && (
                                        <div className="absolute right-2 top-11">
                                            <Loader2 className="h-6 w-6 animate-spin" />
                                        </div>
                                    )}
                                </div>
                                <div className="w-1/2">
                                    <Label htmlFor="area" className="text-lg font-medium">
                                        Customer
                                    </Label>
                                    <CustomerCombobox
                                        // value={customer_Name || customerName}
                                        value={customerName}
                                        onChange={handleCustomerSelect}
                                        options={customerNameList}
                                        placeholder="Select or type customer name"
                                    />
                                </div>
                            </div>
                        </>
                        : <></>}

                    <Button
                        size='lg'
                        style={{ width: '100px' }}
                        onClick={() => {
                            onSavePay();
                        }}
                    >
                        {'PAY'}
                    </Button>
                </DialogFooter>

            </DialogContent>
        </Dialog >
    )

};